<template>
  <div id="app">
    <AppHeader />
    <main class="page-content">
      <router-view />
    </main>
    <AppFooter />
    <MobileMenu :isOpen="mobileMenuOpen" @close="closeMobileMenu" />
  </div>
</template>

<script setup>
import { ref, provide } from 'vue'
import AppHeader from './components/layout/AppHeader.vue'
import AppFooter from './components/layout/AppFooter.vue'
import MobileMenu from './components/layout/MobileMenu.vue'

const mobileMenuOpen = ref(false)

function openMobileMenu() {
  mobileMenuOpen.value = true
}

function closeMobileMenu() {
  mobileMenuOpen.value = false
}

function toggleMobileMenu() {
  mobileMenuOpen.value = !mobileMenuOpen.value
}

provide('mobileMenu', { open: openMobileMenu, close: closeMobileMenu, toggle: toggleMobileMenu })
</script>

<style>
</style>
